var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollContent",staticClass:"scroll-content-horizonal section-custom"},[_vm._l((_vm.data),function(item,index){return _c('MemberNode',{key:index,attrs:{"data":item},on:{"handleChecked":_vm.handleChecked}})}),_vm._v(" "),(!_vm.data.length)?_c('Empty'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/business/select-member/section/section-custom.vue?vue&type=template&id=5d271980&
// module id = 216
// module chunks = 0